export default {
    validate: (value, param) => {

        if (typeof value === 'string') {
            value = value.replace(',', '.')
        }

        if (typeof param[0] === 'string') {
            param[0] = param[0].replace(',', '.')
        }

        return parseFloat(value) >= parseFloat(param[0])
    },
    message: (field, args) => {
        return `${field} deve ser maior ou igual à ${args[0]}.`
    },
}